/**
 * What an email sign-in's refusal means for the page (Storefront G45;
 * mpgadmin G189, CMS G29).
 *
 * One answer for no account, no password yet and a wrong password, so the
 * page can't tell anyone which emails are a salon's clients (Lena, 25 Oct
 * 2026: "specific error messages but use generic ones"). A CMS and API from
 * before then answered 400 (no account) and 409 (no password yet): read the
 * same. Locked (429) shows the server's sentence; not verified (403) offers
 * the resend, and is only said after the right password.
 */
export const SIGN_IN_REFUSED =
  "That email and password don't match. If you've never set a password, use Forgot password.";

export const SIGN_IN_LOCKED = 'Too many sign-in attempts. Try again later, or reset your password.';

export type SignInRefusal =
  | { kind: 'refused'; message: string }
  | { kind: 'locked'; message: string }
  | { kind: 'unverified' }
  | { kind: 'failed' };

export const readSignInRefusal = (status: number, cmsBody: unknown): SignInRefusal => {
  if (status === 401 || status === 400 || status === 409) return { kind: 'refused', message: SIGN_IN_REFUSED };
  if (status === 403) return { kind: 'unverified' };
  if (status === 429) {
    const said = (cmsBody as { error?: unknown } | null)?.error;
    return { kind: 'locked', message: typeof said === 'string' && said.startsWith('Too many') ? said : SIGN_IN_LOCKED };
  }
  return { kind: 'failed' };
};

/**
 * What every sign-up is told (G45): the same for a new email and one that
 * already has an account, which is emailed how to sign in instead.
 */
export const SIGN_UP_SENT =
  "Check your email to finish signing up. If you already have an account, we've emailed you how to sign in.";
